module.exports = __webpack_public_path__ + "static/media/easy-translator.8a2cdeaf.gif";